import { RootState } from '@/shared/store'

import { planningUnassignedTablesAdapter } from '../adapters/planningUnassignedTablesAdapter'

export const planningUnassignedTablesSelector = planningUnassignedTablesAdapter.getSelectors<RootState>(
  (state) => state.planningUnassignedTables,
)
